import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { CalendarColorPicker } from './CalendarColorPicker';
import BackgroundPicker from '../../../widgets/BackgroundPicker';
import cond from 'lodash/cond';

class DateColors extends Component {
    static defaultProps = {
        useCalendarColorPicker: false
    };
    render() {
        return (
            <div className="DateColors">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-3">
                        {this.props.selectedLabel}
                        <BackgroundPicker
                            background={this.props.calendar.date.selected[this.props.type]}
                            preset={this.props.themeColors.primary.colors}
                            isDisabled={this.props.isDisabled}
                            onChange={property =>
                                this.props.onSelectedChange(this.props.type)({
                                    target: {
                                        value: property
                                    }
                                })
                            }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        {this.props.availableLabel}
                        <BackgroundPicker
                            background={this.props.calendar.date.available[this.props.type]}
                            preset={this.props.themeColors.primary.colors}
                            isDisabled={this.props.isDisabled}
                            onChange={property =>
                                this.props.onAvailableChange(this.props.type)({
                                    target: {
                                        value: property
                                    }
                                })
                            }
                        />
                    </div>
                    {cond([
                        [
                            () => this.props.useCalendarColorPicker,
                            () => (
                                <div className="col-xs-12 col-sm-3">
                                    {this.props.pastDate}
                                    <PresetColorPicker
                                        color={this.props.calendar.date.unavailable.background}
                                        isDisabled={this.props.isDisabled}
                                        onColorChange={this.props.setCalendarThemeValue(
                                            'calendar.date.unavailable.background'
                                        )}
                                    />
                                </div>
                            )
                        ],
                        [() => true, () => (
                            <div className="col-xs-12 col-sm-3">
                              {this.props.pastDate}
                              <PresetColorPicker
                                  color={this.props.calendar.date.unavailable.color}
                                  isDisabled={this.props.isDisabled}
                                  onColorChange={this.props.setCalendarThemeValue(
                                      'calendar.date.unavailable.color'
                                  )}
                              />
                            </div>
                        )]
                    ])()}
                    {cond([
                        [
                            () => !this.props.useCalendarColorPicker,
                            () => (
                                <div className="col-xs-12 col-sm-3">
                                    {this.props.unavailableLabel}
                                    <div className="row">
                                        <div className="col-lg-5">
                                            <span style={{ fontSize: '0.8rem', lineHeight: '1', display: 'block' }}>
                                                Text Color
                                            </span>
                                            <PresetColorPicker
                                                color={this.props.calendar.date.unavailableFutureDate.textColor}
                                                isDisabled={this.props.isDisabled}
                                                onColorChange={this.props.setCalendarThemeValue(
                                                    'calendar.date.unavailableFutureDate.textColor'
                                                )}
                                            />
                                        </div>
                                        <div className="col-lg-5">
                                            <span style={{ fontSize: '0.8rem', lineHeight: '1', display: 'block' }}>
                                                Line Color
                                            </span>
                                            <PresetColorPicker
                                                color={this.props.calendar.date.unavailableFutureDate.lineColor}
                                                isDisabled={this.props.isDisabled}
                                                onColorChange={this.props.setCalendarThemeValue(
                                                    'calendar.date.unavailableFutureDate.lineColor'
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        ],
                        [
                            () => true,
                            () => (
                                <div className="col-xs-12 col-sm-3">
                                    {this.props.unavailableLabel}
                                    <PresetColorPicker
                                        color={this.props.calendar.date.unavailableFutureDate.background}
                                        isDisabled={this.props.isDisabled}
                                        onColorChange={this.props.setCalendarThemeValue(
                                            'calendar.date.unavailableFutureDate.background'
                                        )}
                                    />
                                </div>
                            )
                        ]
                    ])()}
                    {cond([
                        [
                            () => this.props.useCalendarColorPicker,
                            () => (
                                <div className="col-xs-12 col-sm-3">
                                    {this.props.noCheckin}
                                    <div className="row">
                                        <div className="col-lg-5">
                                            <CalendarColorPicker
                                                color={this.props.calendar.date.noCheckIn.background}
                                                isDisabled={this.props.isDisabled}
                                                onColorChange={this.props.setCalendarThemeValue(
                                                    'calendar.date.noCheckIn.background'
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        ],
                        [
                            () => true,
                            () => (
                                <div className="col-xs-12 col-sm-3">
                                    {this.props.noCheckin}
                                    <PresetColorPicker
                                        color={this.props.calendar.date.noCheckIn.color}
                                        isDisabled={this.props.isDisabled}
                                        onColorChange={this.props.setCalendarThemeValue(
                                            'calendar.date.noCheckIn.color'
                                        )}
                                    />
                                </div>
                            )
                        ]
                    ])()}
                    {cond([
                        [
                            () => this.props.useCalendarColorPicker,
                            () => (
                                <div className="col-xs-12 col-sm-3">
                                    {this.props.noCheckout}
                                    <div className="row">
                                        <div className="col-lg-5">
                                            <CalendarColorPicker
                                                color={this.props.calendar.date.noCheckOut.background}
                                                isDisabled={this.props.isDisabled}
                                                onColorChange={this.props.setCalendarThemeValue(
                                                    'calendar.date.noCheckOut.background'
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        ],
                        [
                            () => true,
                            () => (
                                <div className="col-xs-12 col-sm-3">
                                    {this.props.noCheckout}
                                    <PresetColorPicker
                                        color={this.props.calendar.date.noCheckOut.color}
                                        isDisabled={this.props.isDisabled}
                                        onColorChange={this.props.setCalendarThemeValue(
                                            'calendar.date.noCheckOut.color'
                                        )}
                                    />
                                </div>
                            )
                        ]
                    ])()}
                </div>
            </div>
        );
    }
}

DateColors.propTypes = {
    tagNameName: PropTypes.string,
    useCalendarColorPicker: PropTypes.bool
};

DateColors.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.app.data.theme.calendar[ownProps.tagName],
        ...state.theme.calendar,
        themeColors: state.app.data.theme.colors
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSelectedChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CALENDAR_SET_DATE_SELECTED,
                    layer: tagName,
                    selected: event.target.value
                });
        },
        onAvailableChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CALENDAR_SET_DATE_AVAILABLE,
                    layer: tagName,
                    available: event.target.value
                });
        },
        onUnavailableChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CALENDAR_SET_DATE_UNAVAILABLE,
                    layer: tagName,
                    unavailable: event.target.value
                });
        },
        onHoverChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CALENDAR_SET_DATE_HOVER,
                    layer: tagName,
                    hover: event.target.value
                });
        },
        setCalendarThemeValue: path => {
            return event =>
                dispatch({
                    type: ActionTypes.SET_CALENDAR_THEME_VALUE,
                    path,
                    value: event.target.value
                });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DateColors);



// WEBPACK FOOTER //
// ./src/components/pages/theme/calendar/DateColors.js